import { useNavigate } from "react-router";
import { useSending } from "./SendingContext";
import { type BannerIcon, sendingBanner } from "./sendingProtection";

/** The banner glyph, matching the locked prototype paths. */
function BannerGlyph({ icon }: { icon: BannerIcon }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {icon === "warn" ? (
        <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
      ) : icon === "pause" ? (
        <>
          <rect x="6" y="4" width="4" height="16" rx="1" />
          <rect x="14" y="4" width="4" height="16" rx="1" />
        </>
      ) : (
        <rect x="4" y="4" width="16" height="16" rx="3" />
      )}
    </svg>
  );
}

/**
 * The persistent, app-wide sending-protection banner (B3). Rendered above the
 * routed content in the operator shell, so it shows on every screen while a
 * workspace is anything but healthy. Its action routes to the in-app status page
 * (Settings → Sending). Reads the global sending status — nothing renders while
 * healthy or before the status has loaded.
 */
export function SendingBanner() {
  const { status } = useSending();
  const navigate = useNavigate();
  const content = status ? sendingBanner(status.state, status.spam_rate) : null;
  if (!content) return null;

  return (
    <div className={`sbanner ${content.tone}`} role="status">
      <span className="ic">
        <BannerGlyph icon={content.icon} />
      </span>
      <div className="sbanner-copy">
        <div className="bt">{content.title}</div>
        <div className="bp">{content.body}</div>
      </div>
      <div className="act">
        <button
          type="button"
          className={`abtn ${content.tone}`}
          onClick={() => navigate("/settings/sending")}
        >
          {content.cta}
        </button>
      </div>
    </div>
  );
}
